// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".svg[data-v-4ca23608] {\n  width: 50vh;\n}\n.align-center-img[data-v-4ca23608] {\n  align-content: center;\n  height: 90vh;\n}\n.p-error-box[data-v-4ca23608] {\n  position: absolute;\n  z-index: 3;\n  top: 69vh;\n}\n.progress-load[data-v-4ca23608] {\n  position: absolute;\n  z-index: 2;\n  top: 50vh;\n}", ""]);
// Exports
module.exports = exports;
